.tabList {
  display: flex;
  gap: 0;
}

.withSpaceAndBorder {
  padding-inline: 16px;
  border-bottom: 1px solid var(--color-border-primary);
}

.tab {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 20px 0;
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  text-decoration: none;
  border-radius: 0;
  transition: color 0.2s ease-in-out;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    // Override silly global border radius on focused links
    border-radius: 0;
    outline-offset: 2px;
  }

  &:not(:global(.active)):is(:hover, :focus) {
    color: var(--color-text-brand-soft);
  }

  &:global(.active) {
    color: var(--color-text-brand);
    border-bottom: 4px solid var(--color-border-brand);
    padding-bottom: 16px;
  }
}
